export const Actions = {
  REFRESH_API_CALL_LOCATION: "REFRESH_API_CALL_LOCATION",
  REFRESH_API_CALL_PERMISSION: "REFRESH_API_CALL_PERMISSION",
  REFRESH_API_CALL_USER: "REFRESH_API_CALL_USER",
  REFRESH_API_CALL_VENDOR: "REFRESH_API_CALL_VENDOR",
  LOCATIONS_LIST: "LOCATIONS_LIST",
  PERMISSION_LIST: "PERMISSION_LIST",
  USERLIST_DATA: "USERLIST_DATA",
  VENDOR_LIST_DATA: "VENDOR_LIST_DATA",
};
